// Learning tracks data aligned with central types
import { LearningTrack, LearningLevel, TrackType } from '@/types/learningPathTypes';

export const ALL_LEARNING_TRACKS: LearningTrack[] = [
  {
    id: 'fullstack-developer',
    name: 'Full Stack Developer',
    description: 'Complete path to become a full stack developer',
    type: 'fullstack',
    estimatedDuration: '12 months',
    icon: '🌐',
    color: '#3B82F6',
    levels: ['beginner', 'intermediate', 'advanced'] as LearningLevel[],
    pathways: [
      {
        id: 'frontend-path',
        name: 'Frontend Development',
        description: 'Master modern frontend development with React',
        level: 'beginner',
        estimatedDuration: '6 months',
        courseIds: ['react-fundamentals', 'javascript-advanced'],
        prerequisites: ['basic-html-css'],
        skills: ['React', 'JavaScript', 'HTML/CSS'],
        outcomes: ['Build responsive UIs', 'Understand React fundamentals'],
        capstoneProject: {
          title: 'Portfolio Website',
          description: 'Build and deploy a personal portfolio website',
          estimatedTime: '2 weeks',
          technologies: ['React', 'Vite', 'Tailwind']
        }
      }
    ]
  },
  {
    id: 'data-scientist',
    name: 'Data Scientist',
    description: 'Master data science and machine learning',
    type: 'datascience',
    estimatedDuration: '10 months',
    icon: '📊',
    color: '#10B981',
    levels: ['beginner', 'intermediate', 'advanced'] as LearningLevel[],
    pathways: [
      {
        id: 'ml-path',
        name: 'Machine Learning',
        description: 'Learn ML fundamentals and model building',
        level: 'intermediate',
        estimatedDuration: '5 months',
        courseIds: ['machine-learning-basics', 'deep-learning'],
        skills: ['Machine Learning', 'Python', 'Statistics'],
        outcomes: ['Train ML models', 'Evaluate and deploy models']
      }
    ]
  },
  {
    id: 'cloud-computing',
    name: 'Cloud Computing Mastery',
    description: 'Learn AWS, Azure, and GCP platforms',
    type: 'cloud',
    estimatedDuration: '7 months',
    icon: '☁️',
    color: '#6366F1',
    levels: ['beginner', 'intermediate'] as LearningLevel[],
    pathways: [
      {
        id: 'azure-path',
        name: 'Azure Specialist',
        description: 'Prepare for Azure certifications',
        level: 'beginner',
        estimatedDuration: '2-3 months',
        courseIds: ['azure-fundamentals'],
        skills: ['Azure', 'Cloud Architecture'],
        outcomes: ['Understand Azure services', 'Prepare for AZ-900']
      }
    ]
  }
];

export const getTrackById = (id: string) => ALL_LEARNING_TRACKS.find(t => t.id === id);
export const getPathwayById = (trackId: string, pathwayId: string) => {
  const track = getTrackById(trackId);
  return track?.pathways.find(p => p.id === pathwayId);
};
